module.exports = __webpack_public_path__ + "img/machine.a25abc8d.jpg";